// Affiliate tag structure 'AFFILIATE:<id>.<code>' on customer
function getAffiliateIdFromTags(tags) {
	const affiliateTag = tags.find((tag) => tag.startsWith('AFFILIATE:'));

	console.log(tags, affiliateTag);
	if (affiliateTag == null) return;

	const [_, affiliateRfsn] = affiliateTag.split(':');
	const [affiliateId, affiliateCode] = affiliateRfsn.split('.');

	return {affiliateId, affiliateCode};
}

async function getAffiliate(id) {
	const response = await fetch(`${EXTERNAL_API_BASE_URL}/affiliate/${id}`).then(res => res.json());
	const affiliate = response.data.affiliates[0]
	
	return affiliate;
}

async function loadAffiliate(id) {
	const affiliate = await getAffiliate(id);

	const myEvent = new CustomEvent(CUSTOM_EVENTS.affiliateLoaded, {
		detail: {
				affiliate
		},
		bubbles: true,
		cancelable: true,
		composed: false,
	});

	window.CURRENT_AFFILIATE = affiliate;

	if (affiliate != null && affiliate.name != null) {
		document.dispatchEvent(myEvent);	
	}
}

// https://www.refersion.dev/reference/new_affiliate_trigger
// Affilaite code is the rfsn_parameter=<affiliate.id>.<affiliate.code>
async function registerEmailWithAffiliate(email, affiliateCode) {
	try {
		const body = {
				affiliate_code: affiliateCode,
				type: REFERSION_CONVERSION_TRIGGER_TYPES.EMAIL,
				trigger: email,
		};
		const response = await fetch(`${EXTERNAL_API_BASE_URL}/conversion/trigger`, { method: 'POST', mode:'cors', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json'}}).then(res => res.json());
		return response;
	} catch(error) {
		console.error(error);
	}
}